/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const NoticeOverViewListPage = lazyLoad(
  () => import('./index'),
  module => module.NoticeOverViewListPage
);
